import Actions                           from 'Redux/Actions';
import { OrganisationInvoiceRepository } from 'Domain/Repositories';
import { ofType }                        from 'redux-observable';
import { from, EMPTY }                   from 'rxjs';
import { mergeMap }                      from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';
import { message }                       from 'antd';

export const downloadOrganisationInvoicePdfEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.downloadOrganisationInvoicePdfRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        OrganisationInvoiceRepository.downloadOrganisationInvoicePdf(id)
          .then(() => {
            return Actions.downloadOrganisationInvoicePdfSuccess();
          })
          .catch((error: any) => Actions.downloadOrganisationInvoicePdfFailure({ error })),
      );
    }),
  );
};
